<div class="public-page">
  <div class="public-container">
    <div class="left">
      <h2>Follow</h2>
      <ul class="social-links">
        <li>
          <a href="http://www.linkedin.com/in/kyra-innovations-225612378">
            <img src="svg/linkedin-icon-2-logo-svgrepo-com.svg" alt="LinkedIn"> LinkedIn
          </a>
        </li>
        <li>
          <a href="https://x.com/KyraInnovations">
            <img src="svg/fa7-brands--x-twitter.svg" alt="Twitter"> 
            Twitter
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/kyrainnovations?igsh=MWt1NHM4YmM3c2tzMA=">
            <img src="svg/instagram-1-svgrepo-com.svg" alt="Instagram"> Instagram
          </a>
        </li>
        <!-- <li>
          <a href="">
            <img src="svg/facebook-svgrepo-com.svg" alt="Facebook"> Facebook
          </a>
        </li> -->
      </ul>
    </div>
    <div class="right">
      <!-- <h1>KYRA</h1> -->
      <img src="logo/Kyra_no_bg.png" alt="">
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
        <!-- <input type="text" id="username" name="username" placeholder="Email / User Name" formControlName="username" required />
        <div  class="error" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
          <small *ngIf="loginForm.get('username')?.errors?.['required']">New Password is required.</small>
        </div>
          <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" name="password" formControlName="password"  placeholder="Password" required/>
          <div  class="error" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            <small *ngIf="loginForm.get('password')?.errors?.['required']">New Password is required.</small>
            <small *ngIf="loginForm.get('password')?.errors?.['minlength']">New Password Should be Minimum 8 characters.</small>
          </div> -->


          <div class="input-group">

            <fa-icon [icon]="['fas', 'envelope']" ></fa-icon>
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/></svg> -->
            <input type="text" id="username" name="username" placeholder="Email / User Name" formControlName="username" required />
          </div>
          <div  class="error" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
            <small *ngIf="loginForm.get('username')?.errors?.['required']">Email or User Name is required.</small>
          </div>
          

          <div class="input-group">
            <fa-icon [icon]="['fas', 'lock']" ></fa-icon>
            <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" name="password" formControlName="password"  placeholder="Password" required/>
            <div (click)="togglePasswordVisibility()">
              <!-- <fa-icon [icon]="isPasswordVisible ? ['fas', 'eye'] : ['fas', 'eye-slash']" class="fa-thin"></fa-icon> -->
              <svg *ngIf="!isPasswordVisible" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"><path fill="currentColor" d="m20.525 21.94l7.768 7.767a1 1 0 0 0 1.414-1.414l-26-26a1 1 0 1 0-1.414 1.414l5.19 5.19c-3.99 3.15-5.424 7.75-5.444 7.823c-.16.53.14 1.08.67 1.24s1.09-.14 1.25-.67c.073-.254 1.358-4.323 4.926-6.99l3.175 3.175a6 6 0 1 0 8.465 8.465m-4.972-9.924l6.43 6.431Q22 18.225 22 18a6 6 0 0 0-6.447-5.984M10.59 7.053L12.135 8.6a12.2 12.2 0 0 1 3.861-.6c9.105 0 11.915 8.903 12.038 9.29c.13.43.53.71.96.71v-.01a.993.993 0 0 0 .96-1.28C29.923 16.61 26.613 6 15.995 6c-2.07 0-3.862.403-5.406 1.053"/></svg>
              <!-- <svg *ngIf="isPasswordVisible" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16"><path fill="currentColor" d="M8 6.003a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334m0 1a1.667 1.667 0 1 0 0 3.334a1.667 1.667 0 0 0 0-3.334m0-3.336c3.076 0 5.73 2.1 6.467 5.043a.5.5 0 1 1-.97.242a5.67 5.67 0 0 0-10.995.004a.5.5 0 0 1-.97-.243A6.67 6.67 0 0 1 8 3.667"/></svg> -->
              <svg  *ngIf="isPasswordVisible" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M3 13c3.6-8 14.4-8 18 0"/><path fill="currentColor" d="M12 17a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/></g></svg>
            </div>
          </div>
          <div  class="error" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            <small *ngIf="loginForm.get('password')?.errors?.['required']">Password is required.</small>
          </div>

          <button type="submit" [disabled]="isLoggingIn">Login

          <fa-icon [icon]="['fas', 'arrow-right-to-bracket']" ></fa-icon>
        </button>
        <div class="frg-pwd">
          <a (click)="forgotPassword()">Forgot Password?</a>
        </div>
        <div class="social-links">
          <ul>
            <li>
              <a href="http://www.linkedin.com/in/kyra-innovations-225612378">
                <img src="svg/linkedin-icon-2-logo-svgrepo-com.svg" alt="LinkedIn">
              </a>
            </li>
            <li>
              <a href="https://x.com/KyraInnovations">
                <img src="svg/fa7-brands--x-twitter.svg" alt="Twitter"> 
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/kyrainnovations?igsh=MWt1NHM4YmM3c2tzMA=">
                <img src="svg/instagram-1-svgrepo-com.svg" alt="Instagram">
              </a>
            </li>
            <!-- <li>
              <a href="">
                <img src="svg/facebook-svgrepo-com.svg" alt="Facebook">
              </a>
            </li> -->
          </ul>
        </div>
      </form>
      <footer>&copy; Copyright {{currentYear}} Kyra Innovations LLP</footer>
    </div>
  </div>
</div>



<!-- Bootstrap responsive -->
<!-- <section class="vh-100">
  <div class="mask d-flex align-items-center h-100">
    <div class="container h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-9 col-lg-7 col-xl-6">
          <div class="card" style="border: none;
                            border-radius: 6px;
                            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
                            max-width: 500px;">
            <div class="card-body  p-3">
              <div class="card-top card-head">
                <h3>Login</h3>
                <p>Please sign in to continue</p>
              </div>
              <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
                  <div class="form-group ">
                    <input type="text" id="username" name="username" [(ngModel)]="username" class="form-control" placeholder=" " required>
                    <label for="username" class="form-label">User Name*</label>
                  </div>
                  <div class="form-group position-relative">
                    <input
                      class="form-control"
                      [type]="isPasswordVisible ? 'text' : 'password'"
                      id="password"
                      name="password"
                      [(ngModel)]="password"
                      placeholder=" "
                      required
                    />
                    <label for="password" class="form-label">Password*</label>
                    <fa-icon
                      [icon]="isPasswordVisible ? ['fas', 'eye'] : ['fas', 'eye-slash']"
                      class="password-icon"
                      (click)="togglePasswordVisibility()"
                    ></fa-icon>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-offset-2 col-sm-10">
                      <div class="checkbox">
                        <label><input type="checkbox" checked /> Remember me</label>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col">
                      <button class="btn btn-primary" style="font-size: 14px;" type="submit" [disabled]="loginForm.invalid">
                        <fa-icon [icon]="['fas', 'unlock-keyhole']" class="fa-thin"></fa-icon>
                        SIGN IN</button>
                    </div>
                    <div class="col text-end">
                      <a role="button" (click)="forgotPassword()" class="text-decoration-none">Forgot Password?</a>
                    </div>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</section> -->